import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import { Label } from 'reactstrap';
import TextInput from '../../../common/forms/input/TextInput';
import { DATE_TIME_FORMAT } from '../../../../config/locale';

const BusMaintenanceStayDateField = ({ input }) => {

  const [disabled, setDisabled] = useState(false);

  const handleNoArrivalTimeChange = () => {
    setDisabled(!disabled);
  }

  return (
    <div>
      <div className="mb-2">
        <Field
          name={`${input.name.split('.')[0]}.estimatedArrivalDate`}
          component={TextInput}
          type="datetime-local"
          placeholder={DATE_TIME_FORMAT}
          disabled={disabled}
        />
      </div>
      <Label className="mb-0">
        <small className="d-flex align-items-center">
          <Field
            name={`${input.name.split('.')[0]}.noArrivalTime`}
            component="input"
            type="checkbox"
            className="mr-2"
            onChange={handleNoArrivalTimeChange}
          />
          Sin hora de llegada
        </small>
      </Label>
    </div>
  )
};

BusMaintenanceStayDateField.propTypes = {
  input: PropTypes.shape({
    name: PropTypes.string,
  }).isRequired,
};

export default BusMaintenanceStayDateField;